import React from "react";
import {
	xhrFileGetExamRequestFile,
	xhrFileGetExamRequestFileListByIds,
} from "../utilities/xhr-file";
import { useDispatch, useSelector } from "react-redux";
import LeftArrow from "../assets/icons/previous-icon.svg";
import RightArrow from "../assets/icons/next-icon.svg";
import { toastUtil, toastUtilText } from "../utilities/toast-util";

const getFileMimeType = (fileName) => {
	const extension = fileName?.split(".").pop()?.toLowerCase();
	const mimeTypes = {
		pdf: "application/pdf",
		jpg: "image/jpeg",
		jpeg: "image/jpeg",
		png: "image/png",
		gif: "image/gif",
		txt: "text/plain",
	};

	return mimeTypes[extension] || "application/octet-stream";
};

function DocumentViewer({ bundledExams, readOnly }) {
	
	const [currDoc, setCurrDoc] = React.useState(0);
	const firstExam = ((bundledExams?.length > 0) ? bundledExams[0] : undefined);
	const [ExamRequestFileList, setExamRequestFileList] = React.useState();
	const token = useSelector((state) => state.session.token);
	const currentLanguage = useSelector((state) => state.session?.userPreferences?.language);

	const loadFiles = React.useCallback(async (bundledExams) => {
		if (bundledExams?.length) {
			let arrayOfIds = bundledExams?.map((x) => x.id).filter((value, index, self) => self.indexOf(value) === index);
			var data = await xhrFileGetExamRequestFileListByIds(token, arrayOfIds);
			toastUtil({ currentLanguage, data });
			setExamRequestFileList(data?.result?.data);
		}
	}, []);
	
	React.useEffect(() => {
		setExamRequestFileList([]);
		loadFiles(bundledExams);
	}, [loadFiles, bundledExams]);

	const isPrevPossible = Boolean(currDoc  !== 0 && ExamRequestFileList?.length);
	const isNextPossible = Boolean(currDoc  !== ExamRequestFileList?.length - 1);

	const [iframeLoading, setiframeLoading] = React.useState(true);

	const [ExamRequestFile, setExamRequestFile] = React.useState(null);
	const [examRequestFileName, setExamRequestFileName] = React.useState("");

	React.useEffect(() => {
		let mountedRef = true;
		let objectUrl = null;
		if (ExamRequestFileList?.[currDoc]?.id) {
			setiframeLoading(true);
			setExamRequestFile(null);
			setExamRequestFileName(ExamRequestFileList[currDoc]?.name || ExamRequestFileList[currDoc]?.extUid || "document");
			
			const effectPromise = async () => {
				var data = await xhrFileGetExamRequestFile(token, ExamRequestFileList?.[currDoc]?.id);
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				if(data?.result){
					const arrayBufferView = data?.result;
					const fileName = ExamRequestFileList[currDoc]?.name || ExamRequestFileList[currDoc]?.extUid || "document";
					const blob = new Blob([arrayBufferView], { type: getFileMimeType(fileName) });
					const urlCreator = window.URL || window.webkitURL;
					objectUrl = urlCreator.createObjectURL(blob);
					setExamRequestFile(objectUrl);
					setExamRequestFileName(fileName);
				}
			}
			effectPromise();
		}
		return () => {
			mountedRef = false;
			if (objectUrl) {
				(window.URL || window.webkitURL).revokeObjectURL(objectUrl);
			}
		};
	}, [currDoc, ExamRequestFileList, currentLanguage, token]);

	return (
		<div className="d-flex flex-column  justify-content-center">
			<h3 style={{ textAlign: 'center'}}>{bundledExams?.map(x => { return x.productName; }).filter((value, index, self) => self.indexOf(value) === index).join(',')}</h3>
			<form className="w-100  light-background border-radius-2">
				{ExamRequestFileList?.length ? (
					<>
						<div className="bg-white d-flex justify-content-between align-items-center">
							<div className="previous-arrowcontainer d-flex align-items-center">
								<button
									className="icon-div  m-0 p-0 border-0 cursor"
									style={{height: '2em'}}
									disabled={!isPrevPossible}
									onClick={async (e) => {
										e.preventDefault();
										setCurrDoc(currDoc - 1);
									}}
								>
									<img src={LeftArrow} alt="prev icon" />
								</button>
								<p className="pl-3 m-0">{ExamRequestFileList[currDoc].extUid} </p>
							</div>
							<div className="next-arrowcontainer d-flex align-items-center">
								<p className="pr-3 m-0">
									{currDoc + 1}/{ExamRequestFileList.length}{" "}
								</p>
								<button
									className="icon-div m-0 p-0 border-0"
									style={{height: '2em'}}
									disabled={!isNextPossible}
									onClick={async (e) => {
										e.preventDefault();
										setCurrDoc(currDoc + 1);
									}}
								>
									<img src={RightArrow} alt="prev icon" />
								</button>
							</div>
						</div>

						<div
							className="bg-white w-100 screenshot-container bg-white d-flex align-items-center justify-content-center"
							style={{ position: "relative" }}
						>
							{Boolean(iframeLoading) && <div className="iframe-loading" />}
							<iframe
								title="DOCUMENT_IFRAME"
								style={{
									width: "100%",
									height: "60vh"
								}}
								onLoad={() => setiframeLoading(false)}
								src={ExamRequestFile}
							/>
							<div
								className="d-flex"
								style={{ position: "absolute", right: "12px", bottom: "12px", zIndex: 2 }}
							>
								<a
									className="btn btn-primary mr-2"
									href={ExamRequestFile || undefined}
									target="_blank"
									rel="noreferrer"
								>
									Open document
								</a>
								<a
									className="btn btn-outline-primary bg-white"
									href={ExamRequestFile || undefined}
									download={examRequestFileName}
								>
									Download document
								</a>
							</div>
						</div>
					</>
				) : (
					<div className="bg-white w-100 screenshot-container bg-white d-flex align-items-center justify-content-center">
						No documents to Display
					</div>
				)}
			</form>
		</div>
	);
}

export default DocumentViewer;
